/**
 * Maps resource URIs to permission scopes that the client-side only application requests for them.
 */
export const PROTECTED_RESOURCE_MAP: [string, string[]][] = [
  ['https://campfire.traveledge.com/', ['api://729da415-f525-4bba-85e3-dad873354db9/CampfireSite.Read']],
  ['https://graph.microsoft.com/v1.0/', ['User.Read', 'Sites.Read.All']],
  ['https://navigatrgroup.sharepoint.com/sites/Campfire/_api/search/query', ['https://navigatrgroup.sharepoint.com/Sites.Search.All']]
];

/**
 * An array of MS Graph permission scopes for the client-side only application.
 */
export const GRAPH_SCOPES: string[] = ['User.Read', 'Sites.Read.All', 'Directory.Read.All', 'Presence.Read', 'Presence.Read.All'];

/**
 * An array of custom permission scopes for accessing our own server-side proxy application
 * from the client-side only application.
 */
export const APP_SCOPES: string[] = ['api://729da415-f525-4bba-85e3-dad873354db9/CampfireSite.Read'];

/**
 * An array of SharePoint Online permission scopes for searching content using client-side only application.
 */
export const SP_SCOPES: string[] = ['https://navigatrgroup.sharepoint.com/Sites.Search.All'];
